import { useState } from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { apiClient } from "./api/client";
import LoginPage from "./pages/LoginPage";
import ScannerPage from "./pages/ScannerPage";
import JournalHub from "./pages/JournalHub";
import InstrumentsPage from "./pages/InstrumentsPage";
import SystemHub from "./pages/SystemHub";
import { Header, SideNav, TabBar } from "./shell/Nav";
import { useTheme } from "./shell/theme";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30000, retry: 1 } }
});

function Shell({ onLogout }: { onLogout: () => void }) {
  const { theme, toggle } = useTheme();
  return (
    <div className="app">
      <SideNav />
      <div className="content">
        <Header theme={theme} onToggleTheme={toggle} />
        <main className="main">
          <ErrorBoundary><Routes>
            <Route path="/"            element={<Navigate to="/scanner" replace />} />
            <Route path="/scanner"     element={<ScannerPage />} />
            <Route path="/journal"     element={<JournalHub />} />
            <Route path="/instruments" element={<InstrumentsPage />} />
            <Route path="/system"      element={<SystemHub onLogout={onLogout} />} />
            {/* alte Adressen (Lesezeichen) */}
            <Route path="/auswertung"  element={<Navigate to="/journal?tab=auswertung" replace />} />
            <Route path="/monitoring"  element={<Navigate to="/system" replace />} />
            <Route path="*"            element={<Navigate to="/scanner" replace />} />
          </Routes></ErrorBoundary>
        </main>
      </div>
      <TabBar />
    </div>
  );
}

export default function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const handleLogin  = (t: string) => { localStorage.setItem("token", t); setToken(t); };
  const handleLogout = () => {
    // Session serverseitig beenden, dann lokal abmelden
    apiClient.post("/auth/logout").catch(() => {}).finally(() => {
      localStorage.removeItem("token"); setToken(null);
    });
  };

  if (!token) return (
    <QueryClientProvider client={queryClient}>
      <LoginPage onLogin={handleLogin} />
    </QueryClientProvider>
  );

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Shell onLogout={handleLogout} />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
